module.exports = __webpack_public_path__ + "img/wait-next-stage.a2962a9a.png";